// src/Products.js
import React, { useState, useEffect } from 'react';
import ProductEdit from './ProductEdit';

const ProductList = ({ authToken }) => {
    const [products, setProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [types, setTypes] = useState([]);
    const [error, setError] = useState(null);
    const [filterCrit, setFilterCrit] = useState('');
    const [editingProductId, setEditingProductId] = useState(null);
    const [isLoading, setIsLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {
            const url = process.env.REACT_APP_BASE_API_URL + 'Menu';
            console.log(url)
            setIsLoading(true);
            try {
                const response = await fetch(url, {
                    headers: {
                        'Authorization': authToken,
                    },
                });

                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();

                const categories = [];
                const types = [];

                data.forEach(product => {
                    // split possible categories into seperate lines
                    const catList = (product.categories || '').split(',');
                    for (var c = 0; c < catList.length; c++) {
                        catList[c] = catList[c].trim();
                        // if category not in array, add
                        if (catList[c] && !categories.includes(catList[c])) {
                            categories.push(catList[c])
                        }
                    }
                    if (product.type && !types.includes(product.type)) {
                        types.push(product.type.trim());
                    }
                });

                categories.sort();
                types.sort();

                setCategories(categories);
                setTypes(types);
                setProducts(data);
            } catch (error) {
                setError(error.message);
            } finally {
                setIsLoading(false);
            }
        };

        fetchData();
    }, [authToken]);

    if (editingProductId) {
        const productToEdit = products.find(product => product.productNumber === editingProductId);
        if (!productToEdit) {
            return (
                <div className='container mt-4'>
                    <p>Product niet gevonden.</p>
                    <button className="btn btn-secondary" onClick={() => setEditingProductId(null)}>Back to list</button>
                </div>
            );
        }

        return (
            <ProductEdit
                product={productToEdit}
                setEditingProductId={setEditingProductId}
                authToken={authToken}
                categoryList={categories}
                typeList={types}
                onProductSaved={(updatedProduct) => {
                    setProducts((prevProducts) =>
                        prevProducts.map((item) =>
                            item.productNumber === updatedProduct.productNumber ? updatedProduct : item
                        )
                    );
                }}
            />
        );
    }

    const toggleOutOfStock = async (productNumber) => {
        setError(null);
        // Find the product to be updated
        const productToUpdate = products.find(product => product.productNumber === productNumber);
        if (!productToUpdate) return;

        // Toggle the outOfStock value
        const updatedProduct = {
            ...productToUpdate,
            outOfStock: productToUpdate.outOfStock === "False" ? "True" : "False"
        };

        try {
            // Make a PUT request to save the updated product
            const url = process.env.REACT_APP_BASE_API_URL + 'Menu';
            const response = await fetch(url, {
                method: 'PUT',
                headers: {
                    //'Content-Type': 'application/json',
                    'Authorization': authToken,
                },
                body: JSON.stringify(updatedProduct)
            });

            if (!response.ok) {
                throw new Error('Failed to update the product');
            }

            // Update the local state if the API call was successful
            setProducts((prevProducts) =>
                prevProducts.map((product) =>
                    product.productNumber === productNumber ? updatedProduct : product
                )
            );
        } catch (error) {
            setError(error.message);
        }
    };

    const filteredProducts = [...products]
        .sort((a, b) => Number(a.productNumber) - Number(b.productNumber))
        .filter(product =>
            product.productNumber.toString().includes(filterCrit) ||
            product.productName.toLowerCase().includes(filterCrit.toLowerCase())
        );


    return (
        <div className='container'>
            <div>
                <button className="btn btn-info" style={{ position: 'absolute', right: 25, top: 25 }} onClick={toLogin}>Return</button>
            </div>
            <h2>Products</h2>
            {error && <p>Error: {error}</p>}
            {isLoading && <p>Loading products...</p>}
            <input
                className="form-control mb-3" // Bootstrap classes for input
                placeholder="Filter products..."
                value={filterCrit}
                onChange={(e) => setFilterCrit(e.target.value)}
            />
            <div className="container">
                {!isLoading && filteredProducts.length === 0 && <p>No matching products found.</p>}
                {filteredProducts
                    .map(product => (
                        <div className='row mb-3' key={product.productNumber}>
                            <div className='col-sm'>
                                {product.productNumber} - {product.productName}
                            </div>
                            <div className='col-sm'>
                                <button className={`btn ${product.outOfStock === "False" ? 'btn-success btn-sm' : 'btn-warning btn-sm'}`} onClick={() => toggleOutOfStock(product.productNumber)}>
                                    {product.outOfStock === "False" ? 'In Stock' : 'Out of Stock'}
                                </button>
                            </div>
                            <div className='col-sm'>
                                <button className="btn btn-primary btn-sm" onClick={() => setEditingProductId(product.productNumber)}>Edit</button>
                            </div>
                        </div>
                    ))
                }
            </div>
        </div>
    );
};

function toLogin() {
    window.location.href = '/login'; // Redirect to login page
}

export default ProductList;